import { forwardRef, memo, useState } from 'react'

import * as SC from './styles/SecuredInputStyles'
import { IconName, IconSize } from 'ui/components/Icon'

import { BaseMaskedInputProps } from './props'
import { InputIconPosition } from './types'

export const SecuredInput = memo(
  forwardRef<HTMLInputElement, BaseMaskedInputProps>((props, ref) => {
    const [secureOn, setSecureOn] = useState(true)

    return (
      <SC.BaseInputStyled
        {...props}
        renderIcon={
          <SC.IconWrapper
            name={secureOn ? IconName.EYE : IconName.EYE_CROSSED}
            size={IconSize.S}
            onClick={() => setSecureOn(!secureOn)}
          />
        }
        iconPosition={InputIconPosition.RIGHT_FAR}
        type={secureOn && props.type ? props.type : 'text'}
        autoComplete={props.autoComplete || 'on'}
        ref={ref}
        $secureOn={secureOn}
      />
    )
  })
)
